import { render, staticRenderFns } from "./PlatformElderByElderNumber.vue?vue&type=template&id=7b3f4fe2&scoped=true&"
import script from "./PlatformElderByElderNumber.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByElderNumber.vue?vue&type=script&lang=js&"
import style0 from "./PlatformElderByElderNumber.vue?vue&type=style&index=0&id=7b3f4fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f4fe2",
  null
  
)

export default component.exports